(function () {
  const sliderSections = document.querySelectorAll('[data-lazy-grid-slider="true"]');
  const lazySections = document.querySelectorAll('[data-lazy-section-id]');

  let sliderScriptRequested = false;

  function loadSliderScript() {
    if (sliderScriptRequested) return;
    sliderScriptRequested = true;

    const scriptUrl = window.themeRoutes && window.themeRoutes.gridSliderScript;
    if (!scriptUrl) return;

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.type = 'module';
    script.defer = true;

    document.head.appendChild(script);
  }

  function observeSliderSections() {
    if (!sliderSections.length) return;

    const sliderObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        loadSliderScript();
        sliderObserver.unobserve(entry.target);
      });
    }, {
      rootMargin: '300px 0px'
    });

    sliderSections.forEach((section) => sliderObserver.observe(section));
  }

  function observeLazySections() {
    if (!lazySections.length) return;

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(async (entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;
        const sectionId = el.getAttribute('data-lazy-section-id');
        const loaded = el.getAttribute('data-lazy-section-loaded');

        if (!sectionId || loaded === 'true') {
          sectionObserver.unobserve(el);
          return;
        }

        el.setAttribute('data-lazy-section-loaded', 'true');
        sectionObserver.unobserve(el);

        try {
          const response = await fetch(`/?sections=${sectionId}`);
          const data = await response.json();

          if (data && data[sectionId]) {
            el.outerHTML = data[sectionId];
            loadSliderScript();
          }
        } catch (error) {
          console.error('Lazy section load failed:', sectionId, error);
        }
      });
    }, {
      rootMargin: '200px 0px'
    });

    lazySections.forEach((section) => sectionObserver.observe(section));
  }

  observeSliderSections();
  observeLazySections();
})();
